/** !WARNING. After we create all new components, we don't need to use this one any more */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Markdown } from '@src/components/Markdown';
import './styles.scss';

export default function SectionTitle({ title, subtitle, size = 'M', className }) {
  const SubTitleComponent = () => {
    if (typeof subtitle === 'object') {
      return <p className={classnames('section-title__subtitle')}>{subtitle}</p>;
    }

    return <Markdown markdown={subtitle} wrapperClassName={classnames('section-title__subtitle')} />;
  };

  return (
    <div className={classnames('section-title', className)}>
      {size === 'XS' && <h6>{title}</h6>}
      {size === 'S' && <h5>{title}</h5>}
      {size === 'M' && <h4>{title}</h4>}
      {size === 'L' && <h3>{title}</h3>}
      {size === 'XL' && <h2>{title}</h2>}
      {size === 'XXL' && <h1>{title}</h1>}
      {subtitle && <SubTitleComponent />}
    </div>
  );
}

SectionTitle.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['XS', 'S', 'M', 'L', 'XL', 'XXL']),
  subtitle: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element]),
};
